import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { isNullOrUndefined } from '@uzurv/core';

export interface ConfirmationDialogData {
  svgIcon?: string;
  svgClass?: string;
  title: string;
  message: string;
  isDestructive: boolean;
  confirmText: string;
  dismissText: string;
}

@Component({
  selector: 'app-confirmation-dialog',
  templateUrl: './confirmation-dialog.component.html',
  styleUrls: ['./confirmation-dialog.component.scss']
})
export class ConfirmationDialogComponent {
  constructor(@Inject(MAT_DIALOG_DATA) public data: ConfirmationDialogData, private dialogref: MatDialogRef<ConfirmationDialogComponent>) {
    if (isNullOrUndefined(data.confirmText)) {
      data.confirmText = 'Confirm';
    }
    if (isNullOrUndefined(data.dismissText)) {
      data.dismissText = 'Cancel';
    }
  }

  onNoClick(): void {
    this.dialogref.close();
  }

  confirm() {
    this.dialogref.close(true);
  }
}
